import { useEffect, useState } from 'react';
import { api, ApiError } from '../lib/api';
import type { TwitchKanal } from '../lib/types';

export function SpielerTwitch({ lobbyId }: { lobbyId: string }) {
  const [offen, setOffen] = useState(() => {
    try {
      return localStorage.getItem('bingo.twitch.offen') === 'true';
    } catch {
      return false;
    }
  });

  const [kanaele, setKanaele] = useState<TwitchKanal[] | null>(null);
  const [fehler, setFehler] = useState<string | null>(null);
  const [laeuft, setLaeuft] = useState(false);

  useEffect(() => {
    let aktiv = true;

    api.meineTwitchKanäle(lobbyId)
      .then((daten) => {
        if (aktiv) setKanaele(daten);
      })
      .catch((err) => {
        if (aktiv) setFehler(err instanceof ApiError ? err.message : 'Twitch-Status konnte nicht geladen werden.');
      });

    return () => { aktiv = false; };
  }, [lobbyId]);

  function umschalten() {
    const naechster = !offen;
    setOffen(naechster);
    try {
      localStorage.setItem('bingo.twitch.offen', String(naechster));
    } catch {
      // Der Bereich funktioniert auch ohne Browserspeicher.
    }
  }

  async function verbinden() {
    setFehler(null);
    setLaeuft(true);
    try {
      const { url } = await api.twitchVerbinden(lobbyId);
      window.location.assign(url);
    } catch (err) {
      setFehler(err instanceof ApiError ? err.message : 'Twitch-Verbindung fehlgeschlagen.');
      setLaeuft(false);
    }
  }

  async function trennen(kanal: TwitchKanal) {
    setFehler(null);
    setLaeuft(true);
    try {
      await api.meinenTwitchKanalTrennen(lobbyId, kanal.id);
      const aktuell = await api.meineTwitchKanäle(lobbyId);
      setKanaele(aktuell);
    } catch (err) {
      setFehler(err instanceof ApiError ? err.message : 'Twitch-Verbindung konnte nicht getrennt werden.');
    } finally {
      setLaeuft(false);
    }
  }

  return (
    <section className="panel">
      <button
        type="button"
        className="ghost"
        aria-expanded={offen}
        onClick={umschalten}
        style={{
          display: 'flex',
          width: '100%',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <strong>Twitch Chat</strong>
        <span aria-hidden="true">{offen ? '▲' : '▼'}</span>
      </button>

      {offen && (
        <div className="stack" style={{ marginTop: 16 }}>
          {kanaele === null && !fehler && (
            <p className="muted small">Twitch-Status wird geladen …</p>
          )}

          {kanaele !== null && kanaele.length > 0 && (
            <>
              <p style={{ color: '#A855F7', fontWeight: 700 }}>
                ● Twitch Chat ist verbunden
              </p>

              {kanaele.map((kanal) => (
                <div key={kanal.id} className="row">
                  <span>@{kanal.login}</span>
                  <button
                    type="button"
                    className="ghost"
                    disabled={laeuft}
                    onClick={() => void trennen(kanal)}
                  >
                    Chat deaktivieren
                  </button>
                </div>
              ))}
            </>
          )}

          {kanaele !== null && kanaele.length === 0 && (
            <p className="muted small">Noch kein eigener Twitch-Kanal verbunden.</p>
          )}

          <button
            type="button"
            className="ghost"
            disabled={laeuft}
            onClick={() => void verbinden()}
          >
            {laeuft ? 'Bitte warten …' : 'Eigenen Twitch-Kanal verbinden'}
          </button>

          {fehler && <p className="notice">{fehler}</p>}
        </div>
      )}
    </section>
  );
}
